import { ClipboardCheck, FileUp, Files, ScanSearch } from "lucide-react";
import InfoContentSection from "@cle/components/InfoContentSection";

/**
 * Deliberately no intro paragraph: HomeView's `description` already tells the
 * member what the page is, and repeating it behind a click costs a step and
 * returns nothing. The dialog covers only what the page cannot show — the tab
 * structure, which types accept a drop, and who reviews what.
 */
const HomeInfoContent = () => {
  return (
    <div className="d-flex flex-column gap-3">
      <InfoContentSection
        icon={Files}
        title="Din dokumentation ligger i faneblade"
      >
        Dokumentationen er delt i syv faneblade: kursusbeviser, forsikring og
        garanti, reduktioner, advokatvagt/retshjælp, dispensation, undervisning
        og forfatterskab. Hvert faneblad viser kun det, der endnu ikke er
        indberettet.
      </InfoContentSection>

      <InfoContentSection icon={FileUp} title="Tilføj dokumentation">
        Du tilføjer dokumentation med knappen øverst i det faneblad, du står i.
        Kursusbeviser og forsikringspolicer kan du desuden trække ind på kortet
        som PDF. Dispensationer kan du ikke selv tilføje — de bliver oprettet
        for dig.
        {/* TODO(sekretariatet): bekræft hvem der opretter en dispensation, og om
            medlemmet skal søge om den et andet sted først. Fanebladet
            "Dispensation" har ingen tilføj-knap, hvilket ser ud som en fejl,
            indtil teksten forklarer det. */}
      </InfoContentSection>

      <InfoContentSection
        icon={ScanSearch}
        title="Kursusbeviser og forsikring kontrolleres automatisk"
      >
        Kursusbeviser og forsikringspolicer bliver gennemgået automatisk, når du
        har uploadet dem. Det tager op til to minutter. Åbn dokumentet for at
        se, hvilke oplysninger der er læst, og om de opfylder kravene. De øvrige
        dokumenttyper bliver gennemgået af sekretariatet.
      </InfoContentSection>

      <InfoContentSection
        icon={ClipboardCheck}
        title="Afventende indberetninger"
      >
        Øverst på siden ser du de perioder og afgørelser, der venter på
        indberetning. En periode kan først indberettes, når den er udløbet —
        indtil da kan du blive ved med at lægge dokumentation ind.
      </InfoContentSection>
    </div>
  );
};

export default HomeInfoContent;
